import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PortalSettingsService } from '../../../core/services/portal-settings.service';
import { concat, from, Observable, of, Subject } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';

//service imports
import { UtilityService } from '../../../core/services/utility.service';
import { ChecklistService } from 'src/app/pages/checklist/services/checklist.service';
import { AdminService } from 'src/app/pages/admin/services/admin.service';
import { EmployeeService } from './../../../pages/employee/services/employee.service';

//Pipe imports
import { OrderByPipe } from '../../../shared/pipe/order-by.pipe';


@Component({
  selector: 'app-view-checklist-workflow-modal',
  templateUrl: './view-checklist-workflow-modal.component.html',
  styleUrls: ['./view-checklist-workflow-modal.component.css']
})
export class ViewChecklistWorkflowModalComponent implements OnInit {
  @ViewChild('signaturePad', { static: false }) signaturePad;
  @Input() checklistInstanceID: number;
  @Input() checklistDetails: any;
  @Input() submitMode: any;
  @Input() isSubmitted: boolean;
  @Input() latitude: any;
  @Input() longitude: any;
  @Input() canNotify: boolean;
  @Input() mode: any;
  portalSettings: any;
  enableCheckboxSign: boolean = false;
  formData: { [key: string]: any } = {};
  confirmRefresh: boolean = false;
  refreshing: boolean = false;
  notifying: boolean = false;
  submitting: boolean = false;
  alert: any;
  reviewers: any[] = [];
  typeSign: boolean = false;
  redBorder: boolean = false;
  submitSignImg: any;
  hideClick: boolean = false;
  showClickMsg: boolean = false;
  emailSendWait: boolean = false;
  orderByPipe: any;
  rowOrder: string;
  reverse: boolean = false;
  checklistInstanceIDs: any;
  rawImgData: any;
  templateCategoryIDs: { [key: string]: number } = { "C": 1, "O": -1, "P": -2, "H": -4 };

  employee$: Observable<any>;
  employeeInput$ = new Subject<any>();
  employeeLoading = false;

  signaturePadOptions: Object = {
    'canvasWidth': 410,
    'canvasHeight': 150
  }

  constructor(portalSettingsService: PortalSettingsService, public activeModal: NgbActiveModal, private utilityService: UtilityService, private checklistService: ChecklistService, private adminService: AdminService, private employeeService: EmployeeService) {
    this.portalSettings = portalSettingsService.getPortalSettings();
  }

  ngOnInit(): void {
    this.orderByPipe = new OrderByPipe();
    this.enableCheckboxSign = this.portalSettings.EnableCheckboxSign.ConfigValue == "1";
    this.getChecklistReviewers(null);
    this.registerLookups();
  }

  private registerLookups() {
    //register observables used by super lookups

    this.employee$ = concat(
      this.employeeInput$.pipe(
        debounceTime(500),
        distinctUntilChanged(),
        switchMap(term => ((term != null && term.length > 1) ?
          from(this.adminService.getHRUsers(term,false,null)).pipe(
            catchError(() => of([]))) : of([])
        ))
      )
    );
  }

  getChecklistReviewers(initialized: any) {
    this.checklistService.getChecklistReviewers(this.checklistInstanceID).then((response: any) => {
      this.refreshing = false;
      if (response.length == 0 && !initialized) {
        this.initializeChecklistReviewers();
      }
      else {
        this.reviewers = response;
      }
    });
  }

  requestRefresh() {
    this.confirmRefresh = true;
  }

  initializeChecklistReviewers() {
    this.refreshing = true;
    this.checklistService.initializeChecklistReviewers(this.checklistInstanceID).then((response: any) => {
      if (response.success) {
        this.getChecklistReviewers(true);
      }
      else {
        this.alert = { type: "danger", msg: response.error };
        this.refreshing = false;
      }
    });
  }

  removeReviewer(reviewer) {
    reviewer.ConfirmDelete = true;
  }

  confirmRemove(reviewer) {
    this.refreshing = true;
    this.checklistService.deleteChecklistReviewers(reviewer.ChecklistRevID).then((response: any) => {
      if (response.success) {
        this.getChecklistReviewers(true);
      }
      else {
        this.alert = { type: "danger", msg: response.error };
        this.refreshing = false;
      }
    })
  }

  addReviewer() {
    this.refreshing = true;
    this.checklistService.addChecklistReviewer(this.formData.selectedEmployee, this.checklistInstanceID, this.mode == "H" ? "Action Item Specific Reviewer" : "Checklist Specific Reviewer").then((response: any) => {
      if (response.success) {
        this.getChecklistReviewers(true);
      }
      else {
        this.alert = { type: "danger", msg: response.error };
        this.refreshing = false;
      }
    });
  }

  submitClicked() {
    if(this.signaturePad != null){
      if (!this.signaturePad.isEmpty() || this.typeSign) {
        this.submitting = true;
        this.notifyReviewers(true);
      } else {
        this.redBorder = true;
      }
    }else if(this.submitSignImg != null){
      this.submitting = true;
        this.notifyReviewers(true);
    }else{
      this.redBorder = true;
    }
  }

  realNotifyReviewers() {
    this.notifying = true;
    this.checklistInstanceIDs = this.checklistInstanceID;
    var filenames = [];
    if (this.checklistDetails.InspectedOnDisplay != null) {
      filenames[0] = this.checklistDetails["ChecklistTemplateName"].replace(/[^0-9a-zA-z]/g, " ") + "_" + this.checklistDetails.InspectedOnDisplay.replace(/\//g, "_") + ".pdf";
    } else {
      filenames[0] = this.checklistDetails["ChecklistTemplateName"].replace(/[^0-9a-zA-z]/g, " ") + ".pdf";
    }
    var templateID = [this.checklistDetails.ChecklistTemplateID];
    var toEmail = [];
    for (var i = 0; i < this.reviewers.length; i++) {
      if (this.reviewers[i].Email != null && this.reviewers[i].Email != "") {
        if (toEmail.indexOf(this.reviewers[i].Email) == -1)
          toEmail.push(this.reviewers[i].Email);
      }
    }
    var subject = this.checklistDetails["ChecklistTemplateName"] + " Routed for your Review";
    var message = "A " + this.checklistDetails["ChecklistTemplateName"] + " has been routed for your review. A copy has been attached to this email, and a direct link to the portal is available below: <br /><br />" + window.location.href;

    this.checklistService.initializeChecklistReviewers(this.checklistInstanceIDs).then((response: any) => {
      if (response.success) {
        this.checklistService.sendChecklists(this.checklistInstanceIDs, filenames, null, toEmail, subject, message, [], [], templateID, null, null, null, null, this.templateCategoryIDs[this.mode]).then((response: any) => {
          if (response.success) {
            this.alert = { type: "success", msg: this.mode == "H" ? "Action Items sent successfully." : "Checklists sent successfully." }
          }
          else {
            this.alert = { type: "danger", msg: response.error }
          }
          this.notifying = false;
          this.emailSendWait = false;
        });
      } else {
        this.notifying = false;
      }
    });
  }

  notifyReviewers(submit) {
    this.notifying = true;
    this.checklistInstanceIDs = this.checklistInstanceID;
    var filenames = [];
    if (this.checklistDetails.InspectedOnDisplay != null) {
      filenames[0] = this.checklistDetails["ChecklistTemplateName"].replace(/[^0-9a-zA-z]/g, " ") + "_" + this.checklistDetails.InspectedOnDisplay.replace(/\//g, "_") + ".pdf";
    } else {
      filenames[0] = this.checklistDetails["ChecklistTemplateName"].replace(/[^0-9a-zA-z]/g, " ") + ".pdf";
    }
    var templateID = [this.checklistDetails.ChecklistTemplateID];
    var toEmail = [];
    for (var i = 0; i < this.reviewers.length; i++) {
      if (this.reviewers[i].Email != null && this.reviewers[i].Email != "") {
        if (toEmail.indexOf(this.reviewers[i].Email) == -1)
          toEmail.push(this.reviewers[i].Email);
      }
    }
    var subject = this.checklistDetails["ChecklistTemplateName"] + " Routed for your Review";
    var message = "A " + this.checklistDetails["ChecklistTemplateName"] + " has been routed for your review. A copy has been attached to this email, and a direct link to the portal is available below: <br /><br />" + window.location.href;

    this.checklistService.sendChecklistSign(this.typeSign ? this.rawImgData : this.signaturePad.toDataURL().replace(/^data:image\/(png|jpg);base64,/, ""), this.checklistInstanceID, this.typeSign, this.latitude, this.longitude).then((response: any) => {
      if (response.success) {
        this.checklistService.sendChecklists(this.checklistInstanceIDs, filenames, null, toEmail, subject, message, [], [], templateID, null, null, null, null, this.templateCategoryIDs[this.mode]).then((response: any) => {
          if (response.success) {
            this.notifying = false;
            this.alert = { type: "success", msg: this.mode == "H" ? "Action Items sent successfully." : "Checklists sent successfully." }
            this.emailSendWait = false;
            if (submit) {
              window.location.href = "/Checklist/Index" + (this.mode == "H" ? ("/#/mode/" + this.mode) : "");
              //$uibModalInstance.close({ data: this.signaturePad.toDataURL(), typeSign: this.typeSign });
            }
          }
          else {
            this.alert = { type: "danger", msg: response.error }
            this.emailSendWait = false;
          }
        });
      }
    });
  }

  setRowSort(col) {
    if (this.rowOrder == col) {
      this.reverse = !this.reverse;
    }
    else {
      this.rowOrder = col;
      this.reverse = false;
    }

    this.reviewers = this.orderByPipe.transform(this.reviewers, this.rowOrder, this.reverse ? "desc" : "asc");
  }

  closeClicked() {
    this.activeModal.close();
  }

  closeAlert() {
    this.alert = null;
  }

  getTypeSign(type: string) {
    if (this.signaturePad.isEmpty()) {
      this.typeSign = true;
      if (this.typeSign) {
        this.employeeService.getTypeSign(type).then((response: any) => {
          this.rawImgData = response;
          this.submitSignImg = "data:image/png;base64," + response;
        });
      }
      this.hideClick = true;
      this.showClickMsg = false;
    } else {
      this.showClickMsg = true;
    }
  }

  clear() {
    this.typeSign = false;
    if (this.signaturePad != null)
      this.signaturePad.clear();
    this.showClickMsg = false;
    this.hideClick = false;
  }

}